import { useCallback, useEffect, useState } from 'react';
import useUserQuery from '../../hooks/queries/useUserQuery';
import { useGetBettieProducts } from '../../../domains/bettie/ui/hooks/useGetBettieProducts';
import { openNewTab } from '../../../utils/UIUtils';
import type { components } from '../../../types/schema';

type ApiV1BettieProduct = components['schemas']['ApiV1BettieProduct'];

export const useBettieCharge = (onClose?: () => void) => {
  const { data: bettieProducts, isFetching: isBettieProductsLoading } = useGetBettieProducts({
    assetType: 'bettie_point'
  });
  const { data: user, refetch: refetchUser, isFetching: isUserFetching } = useUserQuery();

  const [selectedItem, setSelectedItem] = useState<ApiV1BettieProduct | null>(null);
  const [isItemListOpen, setIsItemListOpen] = useState(false);

  useEffect(() => {
    if (bettieProducts?.length) {
      setSelectedItem(bettieProducts[0]);
    }
  }, [bettieProducts]);

  const handleSelectItem = useCallback(
    (id: string) => {
      setSelectedItem(bettieProducts?.find((item) => item.bettieProductId === id) ?? null);
    },
    [bettieProducts]
  );

  useEffect(() => {
    refetchUser();
    const onFocus = () => {
      refetchUser();
    };
    window.addEventListener('focus', onFocus);
    return () => {
      window.removeEventListener('focus', onFocus);
    };
  }, [refetchUser]);

  const handlePrimaryClick = () => {
    if (!selectedItem) return;

    if (selectedItem.category === 'subscription' || selectedItem.category === 'bundle') {
      // requestBillingAuth(selectedItem.bettieProductId);
      onClose?.();
      return;
    }

    const amount = Number(selectedItem.baseAmount - selectedItem.discountAmount);

    if (user?.identified) {
      openNewTab(
        `/payment/inicis?amount=${amount}&productName=${selectedItem.name}&productId=${selectedItem.bettieProductId}`
      );
    } else {
      openNewTab(
        `/identity-verification/intro?amount=${amount}&productName=${selectedItem.name}&productId=${selectedItem.bettieProductId}`
      );
    }
    onClose?.();
  };

  return {
    bettieProducts,
    isBettieProductsLoading,
    isUserFetching,
    selectedItem,
    isItemListOpen,
    setIsItemListOpen,
    handleSelectItem,
    handlePrimaryClick
  };
};

export default useBettieCharge;
